<template>
  <div>
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>My Cloud Booth</BreadcrumbItem>
          <BreadcrumbItem>Brands</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.nameEn}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="$router.push('/exhibitionEn/index/brand/addbrand')">
          <span class="htb-add">+</span>
          <span>Add a brand</span>
        </div>
      </div>
    </div>
    <div class="my-item">
      <template v-if="list && list.items.length">
        <Row :gutter="30">
          <Col style="width:20%;float:left" v-for="(item, index) in list.items" :key="'brandInt-' + index">
            <div class="my-item-box">
              <div class="mi-top">
                <div v-show="!item.isShow" class="brand-show"><i class="icon iconfont icon-hide"></i></div>
                <img :src="item.logo" v-if="item.logo" />
                <img src="@assets/img/empty.png" v-else />
              </div>
              <div class="mi-title f-tac" :title="item.name">{{item.name}}</div>
              <div class="mi-tool">
                <div class="mi-tool-item z-primary" @click="showEdit(item)">Edit</div>
                <div class="mi-tool-line">|</div>
                <template v-if="item.isShow">
                  <div class="mi-tool-item" @click="showOff(item)">Hide</div>
                </template>
                <template v-if="!item.isShow">
                  <div class="mi-tool-item" @click="showOn(item)">display</div>
                </template>
                <div class="mi-tool-line">|</div>
                <div class="mi-tool-item">
                  <Poptip
                    width="160"
                    confirm
                    placement="top-start"
                    title="Confirm deletion?"
                    @on-ok="delItem(item, index)"
                    @on-cancel="handleClose(index)"
                    ok-text="confirm"
                    cancel-text="cancel"
                    popper-class="del-popper"
                  >Delete</Poptip>
                </div>
                <!-- <div class="mi-tool-item">
                  <Dropdown trigger="custom" :visible="item.visible">
                    <a href="javascript:void(0);" style="color:#808080;" @click="toggleOpen(index)">
                      更多
                      <Icon style="margin-left:-3px;" type="ios-arrow-down"></Icon>
                    </a>
                    <DropdownMenu slot="list" style="text-align:center;"> 
                      <DropdownItem v-if="item.isShow" @click.native="showOff(item)">屏蔽</DropdownItem>
                      <DropdownItem v-if="!item.isShow" @click.native="showOn(item)">显示</DropdownItem>
                      <DropdownItem>
                        <Poptip
                          width="160"
                          confirm
                          placement="top-start"
                          title="确认删除此品牌吗 ?"
                          @on-ok="delItem(item, index)"
                          @on-cancel="handleClose(index)"
                        >
                          <div style="width: 100px;">删除</div>
                        </Poptip>
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div> -->
              </div>
            </div>
          </Col>
        </Row>
        <div class="my-page" v-if="totalCount > pageSize">
          <Page
            show-total
            show-elevator
            :page-size="pageSize"
            :current="pageIndex"
            :total="totalCount"
            @on-change="changePage"
            @on-page-size-change="changePageSize"
          />
        </div>
      </template>
      <div class="u-empty" v-else>No data</div>

      <!-- 新增 -->
      <addBrand :show="add" @finish="init()" @close="hideAdd()" />
      <!-- 编辑 -->
      <editBrand :show="edit" :info="editInfo" @finish="init()" @close="hideEdit()" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import addBrand from "./../components/add-brand.vue";
import editBrand from "./../components/edit-brand.vue";
export default {
  name: "all-brand",
  data() {
    return {
      deleted: false,
      edit: false,
      add: false,
      list: null,
      editInfo: null,

      pageSize: 18,
      pageIndex: 1,
      totalCount: 0
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany",
      exhibition: "loginModule/getExhibition"
    }),
    option() {
      return {
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      };
    }
  },
  components: {
    addBrand,
    editBrand
  },
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getBrand: "companyModule/getBrand",
      delBrand: "companyModule/delBrand",
      setBrandShow: "companyModule/setBrandShow"
    }),
    async init() { 
      let result = await this.getBrand(this.option);
      if (result) {
        result.items.map(c => {
          if (c.banner) {
            c.banner = JSON.parse(c.banner);
          }
          c.visible = false;
        });
        this.list = result;
        this.pageSize = result.pageSize;
        this.pageIndex = result.pageIndex;
        this.totalCount = result.totalCount;
      }
    },
    async delItem(item) {
      let result = await this.delBrand(item.id);
      if (result.successed) {
        this.$Message.success("successful");
        this.init();
      } else {
        this.$Message.error("fail,please try again");
      }
    },
    showAdd() {
      this.add = true;
    },
    hideAdd() {
      this.add = false;
    },
    showEdit(item) { 
      this.$router.push(`/exhibitionEn/index/brand/editbrand?id=${item.id}`);
    },
    hideEdit() {
      this.edit = false;
      this.editInfo = null;
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
      
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
      
    },
    // 屏蔽
    async showOff(item) {
      let result = await this.setBrandShow({ "Id": item.id, "IsShow": false});
      if (result.successed) {
        this.$Message.success("successful");
        this.init();
      } else {
        this.$Message.error("fail,please try again");
      }
    },
    // 显示
    async showOn(item) {
      let result = await this.setBrandShow({ "Id": item.id, "IsShow": true});
      if (result.successed) {
        this.$Message.success("successful");
        this.init();
      } else {
        this.$Message.error("fail,please try again");
      }
    },

    handleOpen(index) {
      this.list.items[index].visible = true;
    },
    handleClose(index) {
      this.list.items[index].visible = false;
    },
    toggleOpen(index) {
      let visible = this.list.items[index].visible;
      this.list.items[index].visible = !visible;
    }
  }
};
</script>

<style scoped lang="scss">
.brand-show {
  position:absolute;
  z-index:999;
  right: 0;
  width: 0; 
  height: 0;
  border-width: 20px;
  border-style: solid;
  border-color:#ccc #ccc transparent transparent;
  i {
    position: absolute;
    top: -25px;
    right: -20px;
    color: #fff;
    font-size: 25px;
  }
}
/deep/ .del-popper {
  .ivu-poptip-confirm, .ivu-poptip-footer {
    padding: 8px 14px 16px;
  }
}
</style> 
